import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('sales-credit-policies', storeModule.createStoreModule('sales-credit-policies'))
